import { state } from '__common/store';
import { gable } from '__common/constants/buildingTypes';
import { AttachmentType } from '../../fields/attachmentType';
import { NXTRailClampOption } from '../../fields/railClampOption';
import { s5AttachmentPreferenceDict } from '../s5AttachmentsFilters';

export default () => {
  const { userPreferences: { preferred_span, rafter_spacing_inches, default_project_mode } ,} = state();

  const DEFAULT_VALUES = {
    roof_type : 1,
    s5_or_sci : s5AttachmentPreferenceDict.s_5
  }

  const s5_attachment_roof_type = {
    standing_seam_metal : 2,
    r_panel : 5,
  }

  const NxtHorizonConfig = {
    zipcode: '',
    building_code: 2,
    wind_speed: 110,
    snow_load: 5,
    seismic_ss: 1.20,
    seismic_sds: 0.01,
    tornado_speed : 0,
    elevation: 5499,
    wind_exposure: 'B',
    rail_finish: 'AL',
    roof_type: DEFAULT_VALUES.roof_type,    
    mean_recurrence_interval: 25,
    preferred_span: [s5_attachment_roof_type.standing_seam_metal, s5_attachment_roof_type.r_panel].includes(DEFAULT_VALUES.roof_type) ?  '' : (preferred_span || 72),
    client_name: '',
    rail_direction: 'EW',
    rafter_spacing_inches: [s5_attachment_roof_type.standing_seam_metal, s5_attachment_roof_type.r_panel].includes(DEFAULT_VALUES.roof_type) ?  '' : ( rafter_spacing_inches || 24),
    building_type: gable.value,
    topographical_factor_kzt: 1,
    mid_clamps_choices:4,
    end_clamps_choices:4,
    rail_type:6,
    attachment_type : AttachmentType.STRONGHOLD_ATT_BUTYL,
    roof_substrate: null,
    rail_clamp_option: NXTRailClampOption.RAIL_CLAMP_ONLY,
    stagger_attachments: false,
    is_ul3741_required: '0',
    s5_or_sci: DEFAULT_VALUES.s5_or_sci,
    is_domestic_mlpe_required: 0,
    is_test:default_project_mode
  };
  return NxtHorizonConfig;
};
